/* eslint-disable react/prop-types */
import clsx from "clsx";
import React, { FunctionComponent } from "react";

import { useSearchForm } from "../../stores/hooks/useSearchForm";
import { Chassis } from "./Chassis";
import { PartNumber } from "./PartNumber";
import {
  Tabs,
  tabChassis,
  tabPartNubmer,
  tabTireSize,
  tabVehicle,
} from "./Tabs";
import { TireSize } from "./TireSize";
import { Vehicle } from "./Vehicle";

type SearchFormResultsProps = {
  className?: string;
};

const map = {
  [tabChassis]: Chassis,
  [tabPartNubmer]: PartNumber,
  [tabTireSize]: TireSize,
  [tabVehicle]: Vehicle,
};

export const SearchFormResults: FunctionComponent<SearchFormResultsProps> = ({
  className,
}) => {
  const [{ activeTab }] = useSearchForm();
  const Component = map[activeTab];

  return (
    <section className={clsx("tw-search-form", className)}>
      <div
        className={clsx(
          "flex gap-2 flex-col gap-y-6 rounded-panel max-w-page mx-auto",
          "xl:flex-row xl:rounded-button-group"
        )}
      >
        <Tabs className="self-center sm:self-start xl:self-stretch" compact />
        <Component />
      </div>
    </section>
  );
};
